import axios from "axios";
import { isEmpty } from "lodash";
import { stringify } from "qs";
import moment from "moment-timezone";
export const api = (path, version = "", method = "GET", payload = {}, params, token = "", header = "json", responseType = "") => {
    let endpoint = "API_URL";
    switch (version) {
        case "User":
            endpoint += "fmsuser";
            break;
        case "Vehicle":
            endpoint += "vehicle";
            break;
        case "Tasking":
            endpoint += "fmstasking";
            break;
        case "CMM":
            endpoint = "CMM_API_URL";
            break;
        case "evCharging":
            endpoint += "evCharging";
            break;
        case "Booking":
            endpoint += "booking";
            break;
        case "vsr":
            endpoint += "vsr";
            break;
        case "Internal":
            endpoint += "internal";
            break;
        default:
            endpoint = "";
    }
    const options = {
        url: endpoint + path,
        method: method.toUpperCase(),
        headers: {},
    };
    const needBasicAuth = "NEED_BASIC_AUTH";
    const auth_username = "AUTH_USER_NAME";
    const auth_password = "AUTH_PASSWORD";
    if (token) {
        options["headers"]["Authorization"] = "Bearer " + token;
    }
    if (!token && needBasicAuth) {
        options["auth"] = {
            username: auth_username,
            password: auth_password,
        };
    }
    if (responseType) {
        options["responseType"] = responseType;
    }
    if (!isEmpty(payload) || Object.entries(payload)) {
        options["data"] = payload;
    }
    if (!isEmpty(params)) {
        options["url"] =
            options["url"] + stringify(params, { addQueryPrefix: true });
    }
    switch (header) {
        // if multipart ignore the option headers
        case "multipart":
            options["headers"]["Content-Type"] = "multipart/form-data";
            break;
        case "csv":
            options["headers"]["Accept"] = "application/csv";
            options["responseType"] = "blob";
            break;
        default:
            options["headers"]["Content-Type"] = "application/json";
    }
    return axios(options);
};
export const queryParams = () => {
    let params = new URLSearchParams(window.location.search);
    const entries = params.entries();
    const result = {};
    for (const [key, value] of entries) {
        // each 'entry' is a [key, value] tupple
        result[key] = value;
    }
    return result;
};
export const listQueryParams = (query) => {
    let obj = {};
    for (let key in query) {
        if (key !== "mobileNumber" &&
            key !== "userMobileNumber" &&
            key !== "jobReferenceId" &&
            key !== "vehicleNumber" &&
            key !== "region") {
            if (!isNaN(parseFloat(query[key])) && isFinite(query[key])) {
                obj[key] = parseInt(query[key]);
            }
            else {
                obj[key] = query[key];
            }
        }
        else {
            obj[key] = query[key];
        }
    }
    return obj;
};
//COnvert time to Singapore local time
export const convert = (time) => {
    let eventStartTime = moment
        .utc(time)
        .tz("Asia/Singapore")
        .format("DD MMM YYYY LT");
    return eventStartTime;
};
//Convert time to Singapore local date
export const convertDateOnly = (time, format = "DD MMM YYYY") => {
    if (!time)
        return "";
    let eventStartTime = moment.utc(time).tz("Asia/Singapore").format(format);
    return eventStartTime;
};
//Convert time to Singapore local date
export const convertDateTime = (time, format = "YYYY-MM-DD HH:mm") => {
    let eventStartTime = moment.utc(time).tz("Asia/Singapore").format(format);
    return eventStartTime;
};
//Convert time to Singapore local date
export const convertSGTime = (time) => {
    let eventStartTime = moment.utc(time).tz("Asia/Singapore").format();
    return eventStartTime;
};
export const convertSGDateOnly = (time) => {
    let eventStartTime = moment
        .utc(time)
        .tz("Asia/Singapore")
        .format("YYYY-MM-DD");
    return eventStartTime;
};
//Convert time to Singapore local time
export const convertTimeOnly = (time) => {
    let eventStartTime = moment.utc(time).tz("Asia/Singapore").format("LT");
    return eventStartTime;
};
//Convert to UTC
export const convertDateToUtc = (time) => {
    let eventStartTime = moment.utc(time).format("YYYY-MM-DD HH:mm");
    return eventStartTime;
};
export const convertTimeFormatOnly = (time, format = "YYYY-MM-DD HH:mm") => {
    if (time) {
        let eventStartTime = moment.utc(time).format(format);
        return eventStartTime;
    }
    return "";
};
export const img_endpoint = "IMG_API_URL";
export const formatSummary = (summary) => {
    let words = summary.split(", ");
    words.forEach((word, index) => {
        words[index] = word.charAt(0).toUpperCase() + word.slice(1);
        words[index] = words[index].replace("_", " ");
    });
    return words.join(", ");
};
export const joinErrorMessages = (data, errorCode = null) => {
    let errorMessages = [];
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            const messages = data[key];
            if (Array.isArray(messages)) {
                errorMessages = errorMessages.concat(messages);
            }
        }
    }
    return `Error ${errorCode}: ` + errorMessages.join(" ");
};
export const filterParams = (params) => {
    const filteredParams = {};
    for (const key in params) {
        if (params[key] !== "") {
            filteredParams[key] = params[key];
        }
    }
    return filteredParams;
};
export function timeElapsed(datetimeUTC) {
    // Parse the input datetime string into a Date object
    const inputDate = new Date(datetimeUTC);
    if (isNaN(inputDate.getTime())) {
        throw new Error("Invalid date format. Please provide a valid UTC datetime.");
    }
    // Get the current date
    const currentDate = new Date();
    // Calculate the difference in years, months, and days
    let years = currentDate.getUTCFullYear() - inputDate.getUTCFullYear();
    let months = currentDate.getUTCMonth() - inputDate.getUTCMonth();
    let days = currentDate.getUTCDate() - inputDate.getUTCDate();
    // Adjust the months and years if necessary
    if (days < 0) {
        months -= 1;
        const prevMonth = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), 0);
        days += prevMonth.getUTCDate();
    }
    if (months < 0) {
        years -= 1;
        months += 12;
    }
    // Total months elapsed
    const totalMonths = years * 12 + months;
    return totalMonths > 0
        ? `${totalMonths} months`
        : days > 0
            ? `${days} days`
            : "Today";
}
